export interface TemperatureScaleConfig {
  colors: string[]
  labels: string[]
  thresholds: {
    low: number
    medium: number  
    high: number
  }
}

export const TEMPERATURE_CONFIG: TemperatureScaleConfig = {
  colors: ['#85CD1B', '#FBE728', '#F8751D', '#A70809'],
  labels: ['> 30°', '40°+', '50°+', '60° <'],
  thresholds: {
    low: 30,
    medium: 40,
    high: 50
  }
}